import React from "react";
import { Row, Col } from "antd";
import {
  formatDateSeconds,
  getRestoLogin,
  numberWithCommas,
} from "../../Helpers/Utils/Common";
import "./Print.css";

//logo image

export class CashCountPrint extends React.PureComponent {
  render() {
    const marginTop = "-1000px";
    const marginRight = "60px";
    const marginBottom = "-1000px";
    const marginLeft = "50px";
    const getPageMargins = () => {
      return `@page { margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important; }`;
    };

    return (
      <div className="S">
        <style>{getPageMargins()}</style>
        <div className="print-area rounded p-4 single-width">
          <Row className="d-flex justify-content-center w-100"><h4>{getRestoLogin()?.toUpperCase()}</h4></Row>
          <Row className="d-flex justify-content-between w-100 mt-2">
            <Col className="print-text">Cash Count</Col>
            <Col className="print-text">{this.props.cashier}</Col>
          </Row>
          <Row className="print-text mt-1">
            {formatDateSeconds(new Date())}
          </Row>
          <hr />

          <div className="d-flex row justify-content-center mt-3">
            <label className="d-flex row justify-content-center mb-1 print-text cashcount-text-bold">
              CASH REMITTED
            </label>
          </div>
          <div className="d-flex row justify-content-center mb-1">
            <div className="col-4">
              <label className="d-flex row justify-content-left ms-0 mb-1 print-text">
                Denomination
              </label>
            </div>
            <div className="col-4">
              <label className="d-flex row justify-content-center ms-0 mb-1 print-text">
                Qty
              </label>
            </div>
            <div className="col-4 text-right align-right">
              <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                Amount
              </label>
            </div>
          </div>
          {this.props.billsRemitted?.map((data) => (
            <div className="d-flex row justify-content-center mb-1">
              <div className="col-4">
                <label className="d-flex row justify-content-left ms-0 mb-1 print-text">
                  {data.bill}
                </label>
              </div>
              <div className="col-4">
                <label className="d-flex row justify-content-center ms-0 mb-1 print-text">
                  {data.qty}
                </label>
              </div>
              <div className="col-4 text-right align-right">
                <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                  {numberWithCommas(parseFloat(data.total).toFixed(2))}
                </label>
              </div>
            </div>
          ))}
        {this.props.coinsRemitted?.map((data) => (
            <div className="d-flex row justify-content-center mb-1">
              <div className="col-4">
                <label className="d-flex row justify-content-left ms-0 mb-1 print-text">
                  {data.coin} coin
                </label>
              </div>
              <div className="col-4">
                <label className="d-flex row justify-content-center ms-0 mb-1 print-text">
                  {data.qty}
                </label>
              </div>
              <div className="col-4 text-right align-right">
                <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                  {numberWithCommas(parseFloat(data.total).toFixed(2))}
                </label>
              </div>
            </div>
          ))}
          {this.props.centsRemitted?.map((data) => (
            <div className="d-flex row justify-content-center mb-1">
              <div className="col-4">
                <label className="d-flex row justify-content-left ms-0 mb-1 print-text">
                  {data.cent} cent
                </label>
              </div>
              <div className="col-4">
                <label className="d-flex row justify-content-center ms-0 mb-1 print-text">
                  {data.qty}
                </label>
              </div>
              <div className="col-4 text-right align-right">
                <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                  {numberWithCommas(parseFloat(data.total).toFixed(2))}
                </label>
              </div>
            </div>
          ))}
          <hr />
          <div className="d-flex row justify-content-center mb-1">
            <div className="col-4">
              <label className="d-flex row justify-content-left ms-0 mb-1 print-text"></label>
            </div>
            <div className="col-4">
              <label className="d-flex row justify-content-center ms-0 mb-1 print-text cashcount-text-bold">
                TOTAL:
              </label>
            </div>
            <div className="col-4 text-right align-right">
              <label className="d-flex row justify-content-end ms-0 mb-1 print-text">
                <strong>
                  {numberWithCommas(
                    parseFloat(this.props.totalRemit).toFixed(2)
                  )}
                </strong>
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CashCountPrint;
